<template>
  <div class="sys-border"><slot></slot></div>
</template>

<script>
export default {
  name: "AppBorder"
};
</script>
<style>
.sys-border {
  background-image: url("~sysStatic/images/real/Rectangle1218.png"),
    url("~sysStatic/images/real/Union.png"), url("~sysStatic/images/real/Rectangle1219.png");
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: top left, top right, bottom right;
}
</style>



// WEBPACK FOOTER //
// src/components/AppBorder/index.vue